import { Box, DashboardModule, SortableList } from '@domain-group/suit-theme'

import useIdSort from '@hooks/useIdSort'

import ImageListItem from './ImageListItem'

import type { UseCampaignImagesPayload } from '../../../hooks/useCampaignImages'

interface ListViewProps {
  campaignImagesPayload: UseCampaignImagesPayload,
}

const ListView = (props: ListViewProps) => {
  const { campaignImagesPayload } = props

  const {
    callbacks: {
      getSelectableListItemProps,
      updateImageSort: updateSort,
    },
    campaign,
    filteredImages,
    hasPublicImages,
  } = campaignImagesPayload

  const sortPayload = useIdSort({ callbacks: { updateSort }, idsArray: filteredImages.map(image => image.id) })

  const {
    callbacks: { modifySort },
    sortedIds,
  } = sortPayload

  return (
    // @ts-expect-error TS2322
    <DashboardModule.ScrollableSection maxHeight={600}>
      <SortableList
        callbacks={{
          onDragEnd: (fromIndex, toIndex) => modifySort(fromIndex, toIndex!),
        }}
      >
        <SortableList.Dropzone droppableId={`Section-${campaign.id}`}>
          <Box flexDirection="column">
            {sortedIds.map((imageId, index) => {
              const listItemProps = getSelectableListItemProps(imageId)

              return (
                <SortableList.Item
                  key={`Image-${imageId}`}
                  draggableId={`Image-${imageId}`}
                  index={index}
                >
                  <ImageListItem
                    campaign={campaign}
                    hasPublicImages={hasPublicImages}
                    // @ts-expect-error TS2739
                    image={{ id: imageId }}
                    index={index}
                    key={imageId}
                    {...listItemProps}
                  />
                </SortableList.Item>
              )
            })}
          </Box>
        </SortableList.Dropzone>
      </SortableList>
    </DashboardModule.ScrollableSection>
  )
}

export default ListView
